// extracted by mini-css-extract-plugin
export default {"container":"MobileBgPurpleBlur_container__01Jkh"};